// extracted by mini-css-extract-plugin
module.exports = {"container":"e_DA","up":"e_EA","down":"e_FA","percent":"e_GA","percentVal":"e_HA","title":"e_IA","tags":"e_JA","textBadge":"e_KA"};